import actionTypes from '../common/actionTypes';
import {
	defaultCustomerDetails,
	defaultCustomerFamily,
} from './quotingAPI';

interface State {
	customerDetails: CustomerDemographicDetails;
	customerFamilyList: CustomerFamily[];
	hwTable: HeightWeight[];
	assessment: object;
	validReferral: boolean;
}
const initialState: State = {
	customerDetails: defaultCustomerDetails,
	customerFamilyList: [defaultCustomerFamily],
	hwTable: [],
	assessment: {
		numChildren: '',
		childrenAge: [],
		childrenAge1: '',
		childrenAge2: ''
	},
	validReferral: false
};
export default function quotingReducer(state: State = initialState, action: any) {
	switch (action.type) {
		case actionTypes.FETCH_HEIGHT_WEIGHT_TABLE:
			return { ...state, hwTable: action.hwTable };
		case actionTypes.RESET_CUSTOMER_DETAILS:
			return { ...state, customerDetails: defaultCustomerDetails };
		case actionTypes.FETCH_CUSTOMER_DETAILS:
		case actionTypes.SET_CUSTOMER_DETAILS:
		case actionTypes.SAVE_CUSTOMER_DETAILS:
			return { ...state, customerDetails: action.customerDetails };
		case actionTypes.FETCH_CUSTOMER_FAMILY_LIST:
		case actionTypes.SET_CUSTOMER_FAMILY_LIST:
		case actionTypes.SAVE_CUSTOMER_FAMILY_LIST:
			return { ...state, customerFamilyList: action.customerFamilyList };
		case actionTypes.SET_QUOTING_ASSESSMENT:
			return { ...state, assessment: action.assessment };
		case actionTypes.VALIDATE_REFERRALCODE_SUCCESS:
			return { ...state, validReferral: action.validReferral };
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/quoting/quotingReducer.ts